import Vue from "vue";
import Vuex from "vuex";
import modules from './modules';
// import createPersistedState from 'vuex-persistedstate'
import imageHelper from '@/helpers/imageHelper'
import router from '@/router'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Loading: true,
    Title: '',
    TopImage: '/media/haxdap2u/1324821-6026651-zgnxts76oz.jpg'
  },
  actions: {
    async init({ commit, dispatch }) {
      // Initialize auth first and wait for it
      await dispatch('initAuth')
      // Load recipes first (categories depend on recipes)
      await dispatch('initRecipes')
      // Then sort categories based on loaded recipes
      await dispatch('setSortedCategories')
      commit('setLoading', false)
    }
  },
  mutations: {
    setTitle(state, title) {
      document.title = `Marias Opskrifter | ${title}`
      state.Title = title
    },
    setLoading(state, is) {
      state.Loading = is
    }
  },
  getters: {
    loadingState: state => state.Loading,
    pageTitle: state => state.Title,
    topImage: (state, getters) => {
      if (router.app.$route.name == 'Recipe') {
        return imageHelper.imageBackground(getters.getRecipeById(router.app.$route.params.url).ImageUrl)
      }
      else
        return imageHelper.imageBackground(state.TopImage)
    },
    topImagePosition: (state, getters) => {
      if (router.app.$route.name == 'Recipe') {
        const recipe = getters.getRecipeById(router.app.$route.params.url)
        const fp = recipe && recipe.ImageFocalPoint
        if (fp && typeof fp.x === 'number' && typeof fp.y === 'number') {
          return `${fp.x}% ${fp.y}%`
        }
      }
      return 'center'
    },
  },
  modules: modules,
  // plugins: [createPersistedState()]
});
